import { Badge } from '@bambi/component-library/src/components/Badge/Badge';
import { ClockIcon } from '@heroicons/react/24/outline';

import { CarIcon } from 'src/common/primitives/icon/CarIcon';

import { AssignedDriverRead } from './external/bambi-api/bambiApi';
import { formatFullName } from './util/formatFullName';

export function DriverBadge({ driver }: { driver: AssignedDriverRead }) {
  return (
    <Badge
      icon={
        <>
          <CarIcon />
          {driver.is_currently_clocked_in && (
            <ClockIcon data-testid="clock-icon" className="h-5 w-5" />
          )}
        </>
      }
      label={formatFullName(driver)}
      color="primary-inverse"
    />
  );
}
